export default __webpack_public_path__ + "bfbe469210720087e1e87dbc311cb792.svg";